module.exports = __webpack_public_path__ + "img/login-4.7c477317.jpg";